import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class CanalService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerTodos(callback) {
        this.gqlclient.query({
            query: gql `
        {
          canal {
            obtenerTodos {
              respuesta {
                registros {
                  idcanal
                  descripcion
                }
              }
            }
          }
        }
        `,
            variables: {},
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.canal.obtenerTodos;
            callback({ mensajes, respuesta });
        });
    }
}
CanalService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CanalService_Factory() { return new CanalService(i0.ɵɵinject(i1.GraphQLClient)); }, token: CanalService, providedIn: "root" });
